import { chains, } from "..";
import type { TokenDefinition, ValidChainId, TokenSymbol } from "@bracket/types";


/**
 * @param {boolean} bridge when true getToken will reduce to only tokens flagged as bridgable on platform.
 */
export declare type GetTokensProps = {
	chainId?: ValidChainId;
	swapable?: boolean;
	swapto?: boolean;
	stakable?: boolean;
	inactive?: boolean;
	escrow?: boolean;
	/**ETH is NOT normally returned (it has no contract address("0x0"), but does have other props, ), flag true if you want this definition, default: false. */
	withETH?: boolean;
	withWETH?: boolean;
	withBRKTETH?: boolean;
	bridge?: boolean;
	platform?: boolean;
	platform_supply?: boolean;
	denominable?: boolean;
};

export const getTokens = ({
	chainId = 1,
	inactive = false,
	swapable,
	swapto,
	stakable,
	escrow,
	bridge,
	withETH,
	withWETH,
	withBRKTETH,
	platform,
	platform_supply,
	denominable,
}: GetTokensProps = {}): TokenDefinition[] => {
	let tokens:TokenDefinition[] = [];
	for(const [key, token] of Object.entries(chains[chainId].tokens)) {
		if(key === "ETH" && !withETH)
			continue;
		if(key === "WETH" && !withWETH)
			continue;
		if(key === token.symbol) {
			if(!tokens.find(stk => stk.symbol.toUpperCase() === token.symbol)) {
				tokens.push(token as TokenDefinition);
			}	
		}
	}

	const allTokens:TokenDefinition[] = tokens.concat();


	tokens = swapable === undefined ? tokens : tokens.filter(tk => tk.swapable === swapable);
	tokens = swapto === undefined ? tokens : tokens.filter(tk => tk.swapto === swapto);
	tokens = stakable === undefined ? tokens : tokens.filter(tk => tk.stakable === stakable);
	tokens = inactive === true ? tokens : tokens.filter(tk => tk.inactive === undefined || tk.inactive === false);
	tokens = escrow === undefined ? tokens : tokens.filter(tk => tk.escrow === escrow);
	tokens = platform === undefined ? tokens : tokens.filter(tk => tk.platform === platform);
	tokens = bridge === undefined ? tokens : tokens.filter(tk => tk.bridge === bridge);
	tokens = platform_supply === undefined ? tokens : tokens.filter(tk => tk.platform_supply === platform_supply);
	tokens = withBRKTETH === undefined ? tokens : tokens.concat([allTokens.find(tk => tk.symbol === "BRKTETH")]);
	tokens = denominable === undefined ? tokens : tokens.filter(tk => tk.denominable === denominable);
	return tokens;
}
